export default {
  'TopItems.title': 'Топ продукты',
  'TopItems.products': 'Продукты',
  'TopItems.avgRating': 'Сред. рейтинг',
  'TopItems.sentiment': 'Сентимент',
  'TopItems.best': 'Лучшие',
  'TopItems.worst': 'Худшие',
}
